<div class="container">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <app-workspace-state
      [workspaceStateDraftVersion]="workspaceStateDraftVersion"
      [workspaceStateId]="workspaceStateId"
      [getWorkspaceStateToSave]="getWorkspaceStateToSave"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      (workspaceStateLoaded)="handleLoadWorkspaceResponse($event)"
    ></app-workspace-state>

    @let investorDetailsFormGroupAlertShouldBeVisible =
      submitted && !isInvestorDetailsFormGroupValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          investorDetailsFormGroupAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{ 'PLANNING_ACT_REQUEST.CLIENT_DATA' | translate }}
        </div>

        <div class="card-body">
          <app-investor-details
            [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
            [isEmailRequired]="false"
            [isEPUAPAddressVisible]="true"
            [isPeselVisible]="false"
            [isIdVisible]="false"
            [isPhoneNumberRequired]="false"
            [disabledNaturalPersonData]="true"
            [wasFormValidated]="submitted"
            [loggedUserAddressEditableByExternalForm]="true"
          ></app-investor-details>
        </div>

        @if (investorDetailsFormGroupAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELDS_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <section>
      <div class="card card-border-color-from-db mb-4">
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.IsApplicantOwner">
            {{ 'PLANNING_ACT_REQUEST.OWNERSHIP_FORM' | translate }}
          </label>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <mat-checkbox
                [id]="controlName.IsApplicantOwner"
                [formControlName]="controlName.IsApplicantOwner"
              >
                {{ 'PLANNING_ACT_REQUEST.OWNER_OR_PERPETUAL_USER' | translate }}
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </section>

    @let ownerFormControlAlertShouldBeVisible =
      submitted && !isOwnerIdFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          ownerFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.OwnerId">
            {{ 'PLANNING_ACT_REQUEST.OWNER.LABEL' | translate }}
          </label>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <mat-select
                class="form-select form-select-sm required"
                [id]="controlName.OwnerId"
                [attr.name]="controlName.OwnerId"
                [formControlName]="controlName.OwnerId"
                [placeholder]="
                  'PLANNING_ACT_REQUEST.OWNER.PLACEHOLDER' | translate
                "
              >
                @for (
                  owner of parOwnerService.get(portalId) | async;
                  track owner.id
                ) {
                  <mat-option [value]="owner.id">
                    {{ owner.name | translate }}
                  </mat-option>
                }
              </mat-select>
            </div>
          </div>
        </div>
        @if (ownerFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @if (isRequestTypeVisibe) {
      @let requestTypeFormControlAlertShouldBeVisible =
        submitted && !isRequestTypeFormControlValid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            requestTypeFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.RequestType">
              {{ 'PLANNING_ACT_REQUEST.REQUEST_TYPE.LABEL' | translate }}
            </label>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <mat-select
                  class="form-select form-select-sm required"
                  [id]="controlName.RequestType"
                  [attr.name]="controlName.RequestType"
                  [formControlName]="controlName.RequestType"
                  [placeholder]="
                    'PLANNING_ACT_REQUEST.REQUEST_TYPE.PLACEHOLDER' | translate
                  "
                >
                  @for (
                    requestType of parRequestTypeService.get() | async;
                    track requestType.id
                  ) {
                    <mat-option [value]="requestType.id">
                      {{ requestType.name | translate }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
          </div>
          @if (requestTypeFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>
    }

    @let actTypeFormControlAlertShouldBeVisible =
      submitted && !isActTypeFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          actTypeFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.ActType">
            {{ 'PLANNING_ACT_REQUEST.ACT_TYPE.LABEL' | translate }}
          </label>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <mat-select
                class="form-select form-select-sm required"
                [id]="controlName.ActType"
                [attr.name]="controlName.ActType"
                [formControlName]="controlName.ActType"
                [placeholder]="
                  'PLANNING_ACT_REQUEST.ACT_TYPE.PLACEHOLDER' | translate
                "
              >
                @for (
                  actType of parActTypeService.get() | async;
                  track actType.id
                ) {
                  <mat-option [value]="actType.id">
                    {{ actType.name | translate }}
                  </mat-option>
                }
              </mat-select>
            </div>
          </div>
        </div>
        @if (actTypeFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [addressFormGroupBasedOnSelectControls]="true"
      [multiple]="true"
      [proxyTypeFormControlVisible]="true"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-proxy-details>

    @let letterContentFormControlAlertShouldBeVisible =
      submitted && !isLetterContentFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          letterContentFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.LetterContent">
            {{ 'PLANNING_ACT_REQUEST.LETTER_CONTENT' | translate }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.LetterContent"
                [id]="controlName.LetterContent"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.LetterContent"
              ></textarea>
            </div>
          </div>
        </div>

        @if (letterContentFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <ng-container [formArrayName]="controlName.LetterContentWithParcels">
      @for (
        laneOccupancyAreaFormGroup of getLetterContentWithParcelsFormArray()
          .controls;
        track i;
        let i = $index
      ) {
        <section [formGroupName]="i">
          <div
            class="card mb-4"
            [ngClass]="
              !isLetterContentWithParcelsFormGroupValid(i) && submitted
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              {{
                'PLANNING_ACT_REQUEST.LETTER_CONTENT_WITH_PARCELS.TITLE'
                  | translate
              }}
              #{{ i + 1 }}
              <button
                (click)="deleteLetterContentWithParcelsFormControl(i)"
                type="button"
                title="minus"
                class="btn btn-danger btn-sm float-end"
              >
                <i class="fa fa-times me-2"></i>
                <strong>{{ 'REMOVE' | translate }}</strong>
              </button>
            </div>
            <div class="card-body">
              <gk-map
                [mapState]="
                  (gkKendoGridMapService.$mapStates | async)[
                    this.LETTER_CONTENT_WITH_PARCELS_GROUP
                  ][i]
                "
                (dispatch)="handleLetterContentWithParcelsMapAction($event, i)"
              ></gk-map>
              <div class="my-2">
                @if (
                  getLetterContentWithParcelsMapObjectsTableState(i).mapObjects
                    .length
                ) {
                  <gk-map-object-table
                    [mapState]="
                      getLetterContentWithParcelsMapStateFormControl(i).value
                    "
                    [mapObjectTableStateIndex]="0"
                    (dispatch)="
                      handleLetterContentWithParcelsMapAction($event, i)
                    "
                  ></gk-map-object-table>
                }
              </div>
              <div class="mb-2">
                <label
                  [attr.for]="
                    letterContentWithParcelsControlName.ActName + '-' + i
                  "
                >
                  {{
                    'PLANNING_ACT_REQUEST.LETTER_CONTENT_WITH_PARCELS.ACT_NAME'
                      | translate
                  }}
                </label>
                <input
                  type="text"
                  [name]="letterContentWithParcelsControlName.ActName + '-' + i"
                  [id]="letterContentWithParcelsControlName.ActName + '-' + i"
                  class="form-control form-control-sm required"
                  aria-required="true"
                  [formControlName]="
                    letterContentWithParcelsControlName.ActName
                  "
                />
                @if (
                  shouldShowRequiredAlert(
                    getLetterContentWithParcelsActNameFormControl(i)
                  )
                ) {
                  <div class="alert alert-danger mt-2">
                    {{ 'FIELD_REQUIRED' | translate }}
                  </div>
                }
              </div>
              <div class="mb-2">
                <label [attr.for]="letterContentWithParcelsControlName.Content">
                  {{
                    'PLANNING_ACT_REQUEST.LETTER_CONTENT_WITH_PARCELS.CONTENT'
                      | translate
                  }}
                </label>
                <textarea
                  [name]="letterContentWithParcelsControlName.Content + '-' + i"
                  [id]="letterContentWithParcelsControlName.Content + '-' + i"
                  class="form-control form-control-sm required"
                  aria-required="true"
                  [formControlName]="
                    letterContentWithParcelsControlName.Content
                  "
                ></textarea>
                @if (
                  shouldShowRequiredAlert(
                    getLetterContentWithParcelsContentFormControl(i)
                  )
                ) {
                  <div class="alert alert-danger mt-2">
                    {{ 'FIELD_REQUIRED' | translate }}
                  </div>
                }
              </div>
              <div class="mb-2">
                <mat-checkbox
                  class="p-0"
                  [formControlName]="
                    letterContentWithParcelsControlName.IsAreaCoversAllParcels
                  "
                >
                  {{
                    'PLANNING_ACT_REQUEST.LETTER_CONTENT_WITH_PARCELS.IS_AREA_COVERS_ALL_PARCELS'
                      | translate
                  }}</mat-checkbox
                >
              </div>
            </div>
            @if (
              submitted && !isSomeParcelsForLetterContentWithParcelsChosen(i)
            ) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'PARCELS_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>
      }
    </ng-container>

    <section>
      <div class="card card-border-color-from-db mb-4">
        <div class="card-header card-header-color-from-db">
          {{
            'PLANNING_ACT_REQUEST.LETTER_CONTENT_WITH_PARCELS.TITLE' | translate
          }}
        </div>

        <div class="card-body d-grid">
          <button
            (click)="addLetterContentWithParcelsFormControl()"
            type="button"
            title="plus"
            class="btn btn-lg btn-outline-dark fa fa-plus"
          ></button>
        </div>
      </div>
    </section>

    @if (isLetterDetailsSectionShouldBeVisible()) {
      <ng-container [formArrayName]="controlName.LetterDetails">
        @for (
          laneOccupancyAreaFormGroup of getLetterDetailsFormArray().controls;
          track i;
          let i = $index
        ) {
          <section [formGroupName]="i">
            <div
              class="card mb-4"
              [ngClass]="
                !isLetterDetailsFormGroupValid(i) && submitted
                  ? 'border-danger border-2'
                  : 'card-border-color-from-db'
              "
            >
              <div class="card-header card-header-color-from-db">
                {{ 'PLANNING_ACT_REQUEST.LETTER_DETAILS.TITLE' | translate }}
                #{{ i + 1 }}
                <button
                  (click)="deleteLetterDetailsFormControl(i)"
                  type="button"
                  title="minus"
                  class="btn btn-danger btn-sm float-end py-0"
                >
                  <i class="fa fa-times me-2"></i>
                  <strong>{{ 'REMOVE' | translate }}</strong>
                </button>
              </div>
              <div class="card-body">
                <gk-map
                  [mapState]="
                    (gkKendoGridMapService.$mapStates | async)[
                      this.LETTER_DETAILS_GROUP
                    ][i]
                  "
                  (dispatch)="handleLetterDetailsMapAction($event, i)"
                ></gk-map>
                <div class="my-2">
                  @if (
                    getLetterDetailsMapObjectsTableState(i).mapObjects.length
                  ) {
                    <gk-map-object-table
                      [mapState]="getLetterDetailsMapStateFormControl(i).value"
                      [mapObjectTableStateIndex]="0"
                      (dispatch)="handleLetterDetailsMapAction($event, i)"
                    ></gk-map-object-table>
                  }
                </div>
                <div class="mb-2">
                  <label
                    [attr.for]="letterDetailsControlName.ActName + '-' + i"
                  >
                    {{
                      'PLANNING_ACT_REQUEST.LETTER_DETAILS.ACT_NAME' | translate
                    }}
                  </label>
                  <input
                    type="text"
                    [name]="letterDetailsControlName.ActName + '-' + i"
                    [id]="letterDetailsControlName.ActName + '-' + i"
                    class="form-control form-control-sm required"
                    aria-required="true"
                    [formControlName]="letterDetailsControlName.ActName"
                  />
                  @if (
                    shouldShowRequiredAlert(
                      getLetterDetailsActNameFormControl(i)
                    )
                  ) {
                    <div class="alert alert-danger mt-2">
                      {{ 'FIELD_REQUIRED' | translate }}
                    </div>
                  }
                </div>
                <div class="mb-2 position-relative">
                  <gk-land-use-class-form
                    [form]="laneOccupancyAreaFormGroup"
                    [submitted]="submitted"
                  ></gk-land-use-class-form>
                </div>
                <div class="mb-2 row">
                  <div class="col-12 col-xxl">
                    <label
                      [attr.for]="
                        letterDetailsControlName.MaxBuildingCoverage + '-' + i
                      "
                    >
                      {{
                        'PLANNING_ACT_REQUEST.LETTER_DETAILS.MAX_BUILDING_COVERAGE'
                          | translate
                      }}
                    </label>
                    <div class="input-group input-group-sm">
                      <input
                        type="number"
                        [name]="
                          letterDetailsControlName.MaxBuildingCoverage + '-' + i
                        "
                        [id]="
                          letterDetailsControlName.MaxBuildingCoverage + '-' + i
                        "
                        class="form-control form-control-sm required"
                        aria-required="true"
                        min="0"
                        max="100"
                        [formControlName]="
                          letterDetailsControlName.MaxBuildingCoverage
                        "
                      />
                      <span class="input-group-text">%</span>
                    </div>
                    @let letterDetailsMaxBuildingCoverageFormControl =
                      getLetterDetailsMaxBuildingCoverageFormControl(i);
                    @if (
                      shouldShowRequiredAlert(
                        letterDetailsMaxBuildingCoverageFormControl
                      )
                    ) {
                      <div class="alert alert-danger mt-2">
                        {{ 'FIELD_REQUIRED' | translate }}
                      </div>
                    } @else if (
                      shouldShowMinMaxAlert(
                        letterDetailsMaxBuildingCoverageFormControl
                      )
                    ) {
                      <gk-min-max-alert
                        [formControlInstance]="
                          letterDetailsMaxBuildingCoverageFormControl
                        "
                      ></gk-min-max-alert>
                    }
                  </div>
                  <div class="col-12 col-xxl">
                    <label
                      [attr.for]="
                        letterDetailsControlName.MaxBuildingHeight + '-' + i
                      "
                    >
                      {{
                        'PLANNING_ACT_REQUEST.LETTER_DETAILS.MAX_BUILDING_HEIGHT'
                          | translate
                      }}
                    </label>
                    <div class="input-group input-group-sm">
                      <input
                        type="number"
                        [name]="
                          letterDetailsControlName.MaxBuildingHeight + '-' + i
                        "
                        [id]="
                          letterDetailsControlName.MaxBuildingHeight + '-' + i
                        "
                        class="form-control form-control-sm required"
                        aria-required="true"
                        [formControlName]="
                          letterDetailsControlName.MaxBuildingHeight
                        "
                      />
                      <span class="input-group-text">m</span>
                    </div>
                    @let letterDetailsMaxBuildingHeightFormControl =
                      getLetterDetailsMaxBuildingHeightFormControl(i);
                    @if (
                      shouldShowRequiredAlert(
                        letterDetailsMaxBuildingHeightFormControl
                      )
                    ) {
                      <div class="alert alert-danger mt-2">
                        {{ 'FIELD_REQUIRED' | translate }}
                      </div>
                    } @else if (
                      shouldShowMinMaxAlert(
                        letterDetailsMaxBuildingHeightFormControl
                      )
                    ) {
                      <gk-min-max-alert
                        [formControlInstance]="
                          letterDetailsMaxBuildingHeightFormControl
                        "
                      ></gk-min-max-alert>
                    }
                  </div>
                  <div class="col-12 col-xxl">
                    <label
                      [attr.for]="
                        letterDetailsControlName.MinBiologicallyActiveArea +
                        '-' +
                        i
                      "
                    >
                      {{
                        'PLANNING_ACT_REQUEST.LETTER_DETAILS.MIN_BIOLOGICALLY_ACTIVE_AREA'
                          | translate
                      }}
                    </label>
                    <div class="input-group input-group-sm">
                      <input
                        type="number"
                        [name]="
                          letterDetailsControlName.MinBiologicallyActiveArea +
                          '-' +
                          i
                        "
                        [id]="
                          letterDetailsControlName.MinBiologicallyActiveArea +
                          '-' +
                          i
                        "
                        class="form-control form-control-sm required"
                        aria-required="true"
                        min="0"
                        max="100"
                        [formControlName]="
                          letterDetailsControlName.MinBiologicallyActiveArea
                        "
                      />
                      <span class="input-group-text">%</span>
                    </div>
                    @let letterDetailsMinBiologicallyActiveAreaFormControl =
                      getLetterDetailsMinBiologicallyActiveAreaFormControl(i);
                    @if (
                      shouldShowRequiredAlert(
                        letterDetailsMinBiologicallyActiveAreaFormControl
                      )
                    ) {
                      <div class="alert alert-danger mt-2">
                        {{ 'FIELD_REQUIRED' | translate }}
                      </div>
                    } @else if (
                      shouldShowMinMaxAlert(
                        letterDetailsMinBiologicallyActiveAreaFormControl
                      )
                    ) {
                      <gk-min-max-alert
                        [formControlInstance]="
                          letterDetailsMinBiologicallyActiveAreaFormControl
                        "
                      ></gk-min-max-alert>
                    }
                  </div>
                </div>
                <div class="mb-2">
                  <mat-checkbox
                    class="p-0"
                    [formControlName]="
                      letterDetailsControlName.IsAreaCoversAllParcels
                    "
                  >
                    {{
                      'PLANNING_ACT_REQUEST.LETTER_DETAILS.IS_AREA_COVERS_ALL_PARCELS'
                        | translate
                    }}</mat-checkbox
                  >
                </div>
              </div>
              @if (submitted && !isSomeParcelsForLetterDetailsChosen(i)) {
                <div class="card-footer">
                  <div class="alert alert-danger my-2">
                    {{ 'PARCELS_REQUIRED' | translate }}
                  </div>
                </div>
              }
            </div>
          </section>
        }
      </ng-container>

      <section>
        <div class="card card-border-color-from-db mb-4">
          <div class="card-header card-header-color-from-db">
            {{ 'PLANNING_ACT_REQUEST.LETTER_DETAILS.TITLE' | translate }}
          </div>

          <div class="card-body d-grid">
            <button
              (click)="addLetterDetailsFormControl()"
              type="button"
              title="plus"
              class="btn btn-lg btn-outline-dark fa fa-plus"
            ></button>
          </div>
        </div>
      </section>
    }

    <app-electronic-correspondence-statement
      #electronicCorrespondenceStatement
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    >
    </app-electronic-correspondence-statement>

    <gk-attachments
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      [nonElectronicForm]="
        electronicCorrespondenceStatement.getElectronicCorrespondenceStatementFormControl()
          ?.value !== true
      "
    ></app-request-reply-form>

    <app-request-validation-info
      [shouldShowProvideFieldsAlert]="submitted && !isRequestValid()"
      [errorSubmitMessage]="errorSubmitMessage"
    ></app-request-validation-info>

    <section class="my-2">
      <app-cautions
        [portalId]="portalId"
        [formGroup]="formGroup"
        [submitted]="submitted"
        [borderClass]="'card-border-color-from-db'"
        [backgroundClass]="'card-header-color-from-db'"
        [buttonClass]="'btn-color-from-db'"
      ></app-cautions>
    </section>

    <section>
      <button type="submit" class="btn btn-color-from-db">
        {{ 'PLANNING_ACT_REQUEST.SUBMIT' | translate }}
      </button>

      <app-request-preview-button
        class="ms-2"
        [buttonClass]="'btn-color-from-db'"
        [getPreviewRequestBody]="getRequestBody"
        [previewRequestUrl]="requestPreviewUrl"
      ></app-request-preview-button>

      <app-request-cancel-button></app-request-cancel-button>

      <app-doc-sign-info
        [messageText]="docSignMsgTxt"
        [messageType]="docSignMsgType"
        [docSignUrl]="docSignUrl"
        [docSignPending]="docSignPending"
      ></app-doc-sign-info>

      <div class="mt-2"><app-form-legend></app-form-legend></div>
    </section>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
